__webpack_require__.p = "/custom-colors-remapping/referrals-hub/";